export const AssessmentStates = {
  FULL_SCREEN_PERMISSION: "FULL_SCREEN_PERMISSION",
  SHOWING_TUTORIAL: "SHOWING_TUTORIAL",
  FETCHING_CHALLENGE: "FETCHING_CHALLENGE",
  STARTING: "STARTING",
  RUNNING: "RUNNING",
  FINISHING: "FINISHING",
};

export const QuestionStates = {
  WAITING: "WAITING",
  CODING: "CODING",
  CODE_EVALUATING: "CODE_EVALUATING",
  CODE_SUBMITTED: "CODE_SUBMITTED",
  FETCHING_QUESTIONS: "FETCHING_QUESTIONS",
  INTERVIEWER_ASKING: "INTERVIEWER_ASKING",
  RECORDING: "RECORDING",
  RECORDED: "RECORDED",
};

export const InterviewerStates = {
  LISTINING: "LISTENING",
  SPEAKING: "SPEAKING",
};

export const QuestionsTypes = {
  MAIN: "main",
  FOLLOW_UP_1: "follow_up_1",
  FOLLOW_UP_2: "follow_up_2",
};

export const SectionWiseData = {
  main: {
    codingTime: 2100,
    codingWarningTime: 120,
    explanationTime: 180,
    explanationWarningTime: 10,
  },
  follow_up_1: {
    codingTime: 480,
    codingWarningTime: 60,
    explanationTime: 120,
    explanationWarningTime: 10,
  },
  follow_up_2: {
    codingTime: 480,
    codingWarningTime: 60,
    explanationTime: 120,
    explanationWarningTime: 10,
  },
};

export const AudioCues = {
  Main_Intro_Cues: [
    {
      text: "In this session, we’ll go through a coding problem. You'll have to think of an approach & then code, and optimize your solution. After coding, we’ll discuss your approach and explore optimizations.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_0.mp3'
    },
    {
      text: 'In this session, we will tackle a coding problem. You need to devise an approach, implement it, and then optimize the solution. After coding, we’ll analyze and discuss improvements.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_1.mp3'
    },
    {
      text: 'We’ll go through a programming problem today. Your task is to think of an approach, write the code, and optimize it. After that, we’ll review and refine your solution.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_2.mp3'
    },
    {
      text: 'This session is focused on solving a coding challenge. You will plan your approach, implement it, and optimize it. We will then discuss and analyze improvements.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_3.mp3'
    },
    {
      text: 'We are solving a coding problem in this session. First, devise an approach, then code it, and finally, optimize it. We’ll review and refine your solution afterward.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_4.mp3'
    },
    {
      text: 'Our task today is to work through a coding problem. You’ll create a strategy, write the solution, and optimize it. Then, we’ll analyze and enhance your approach.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_5.mp3'
    },
    {
      text: 'We’ll be working through a coding exercise. You need to define an approach, write the solution, and optimize it. After coding, we’ll discuss and improve it.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_6.mp3'
    },
    {
      text: 'This session will involve solving a coding challenge. You will design an approach, implement it, and refine it for efficiency. Then, we will discuss possible optimizations.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_7.mp3'
    },
    {
      text: 'Today’s session involves a programming problem. First, develop an approach, then implement it, and optimize it. We will then review and explore refinements.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_8.mp3'
    },
    {
      text: 'You will tackle a coding problem by forming an approach, implementing it, and optimizing it. After that, we’ll analyze the solution and discuss enhancements.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_9.mp3'
    },
    {
      text: 'We will work through a coding problem by thinking through an approach, implementing it, and optimizing it. After that, we will discuss further refinements.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Intro_Cues_audio_10.mp3'
    }
  ],
  Main_Hint_Cues: [
    {
      text: "If you'd like, you can take a hint now.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_11.mp3'
    },
    {
      text: 'If you want, you can take a hint now to guide your thinking.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_12.mp3'
    },
    {
      text: 'You may take a hint now if you feel it would be helpful.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_13.mp3'
    },
    {
      text: 'Would you like a hint at this point?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_14.mp3'
    },
    {
      text: 'Feel free to take a hint now if needed.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_15.mp3'
    },
    {
      text: 'Would you prefer to take a hint before proceeding?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_16.mp3'
    },
    {
      text: 'You can take a hint if you think it will help.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_17.mp3'
    },
    {
      text: "If you're unsure, a hint might be useful now.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_18.mp3'
    },
    {
      text: 'A hint is available if you want one.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_19.mp3'
    },
    {
      text: 'Would a hint help you at this point?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_20.mp3'
    },
    {
      text: "If you'd like some guidance, you can take a hint now.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Hint_Cues_audio_21.mp3'
    }
  ],
  Main_Explanation_Cues: [
    {
      text: "Now let's review your code. Before that, can you provide an exhaustive explanation of your approach? Walk me through your logic, the data structures used, and any edge cases you considered.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_22.mp3'
    },
    {
      text: 'Before we review your code, can you provide an in-depth explanation of your approach?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_23.mp3'
    },
    {
      text: "Let's analyze your solution. First, explain your thought process in detail.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_24.mp3'
    },
    {
      text: 'Now, walk me through your logic, the data structures you used, and edge cases you considered.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_25.mp3'
    },
    {
      text: "We're about to review your code. Please provide a complete breakdown of your approach.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_26.mp3'
    },
    {
      text: "Let's discuss your implementation. Can you explain your approach step by step?",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_27.mp3'
    },
    {
      text: 'Before reviewing, describe the key decisions behind your code and its efficiency.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_28.mp3'
    },
    {
      text: "We'll now analyze your code. Explain the methodology and any trade-offs you made.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_29.mp3'
    },
    {
      text: 'Please walk me through your logic, covering all the important details.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_30.mp3'
    },
    {
      text: "Now let's evaluate your solution. First, provide an extensive explanation of your approach.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_31.mp3'
    },
    {
      text: 'Explain how you structured your solution, the choices you made, and the optimizations applied.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Explanation_Cues_audio_32.mp3'
    }
  ],
  Main_Timeout1_Cues: [
    {
      text: "Let's try to finish the code in the next 10 minutes. If you're stuck, feel free to take another hint.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_33.mp3'
    },
    {
      text: "Try to complete your code in the next 10 minutes. If you're stuck, you can take another hint.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_34.mp3'
    },
    {
      text: "Let's aim to finish your code within 10 minutes. If needed, hints are available.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_35.mp3'
    },
    {
      text: "We'll try to wrap up coding in 10 minutes. Feel free to ask for a hint if you need help.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_36.mp3'
    },
    {
      text: 'You have 10 minutes to complete your solution. If you need guidance, you can take a hint.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_37.mp3'
    },
    {
      text: "Let's push to finish your code in 10 minutes. A hint is available if required.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_38.mp3'
    },
    {
      text: 'Complete your implementation in the next 10 minutes. If you get stuck, hints are here to help.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_39.mp3'
    },
    {
      text: 'Try to finalize your code within 10 minutes. I can offer hints if needed.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_40.mp3'
    },
    {
      text: 'Aim to finish coding in 10 minutes. Hints are available if necessary.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_41.mp3'
    },
    {
      text: 'We have 10 minutes to complete the code. Feel free to take a hint if needed.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_42.mp3'
    },
    {
      text: "Let's try to complete your coding task in the next 10 minutes. Ask for a hint if required.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout1_Cues_audio_43.mp3'
    }
  ],
  Main_Timeout2_Cues: [
    {
      text: "You have 2 more minutes to complete your code, after which we'll discuss and optimize it.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_44.mp3'
    },
    {
      text: 'You have 2 more minutes to wrap up your code before we discuss and optimize it.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_45.mp3'
    },
    {
      text: "Just 2 minutes left to complete your code, after which we'll analyze and improve it.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_46.mp3'
    },
    {
      text: 'Finish up your code in the next 2 minutes before we move on to discussing improvements.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_47.mp3'
    },
    {
      text: "Two minutes remaining! Then we'll discuss and optimize your solution.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_48.mp3'
    },
    {
      text: 'Hurry up! Only 2 minutes are left before we begin refining your approach.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_49.mp3'
    },
    {
      text: 'Just 2 minutes left before we review and explore optimizations.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_50.mp3'
    },
    {
      text: 'Wrap up your solution in the next 2 minutes so we can discuss enhancements.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_51.mp3'
    },
    {
      text: 'Use the remaining 2 minutes to finalize your code before optimization.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_52.mp3'
    },
    {
      text: "Time's almost up! Finish your code so we can analyze it.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_53.mp3'
    },
    {
      text: "Only 2 minutes to go! Let's get your code ready for discussion.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Main_Timeout2_Cues_audio_54.mp3'
    }
  ],
  Followup_Intro_Cues: [
    {
      text: 'Let’s dive deeper into your solution and explore possible optimizations—a follow-up question will guide this exploration.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_55.mp3'
    },
    {
      text: 'Let’s take a closer look at your solution and discuss possible ways to improve it; a follow-up question is on the way.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_56.mp3'
    },
    {
      text: 'Now, we’ll analyze your implementation and explore optimizations, followed by a question to dig further.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_57.mp3'
    },
    {
      text: 'Let’s evaluate your solution and find ways to make it more efficient—a follow-up question will help drive that.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_58.mp3'
    },
    {
      text: 'We’ll now look at optimizations to enhance your solution’s performance, and a follow-up question will support this step.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_59.mp3'
    },
    {
      text: 'Let’s refine your approach and explore ways to improve efficiency; a follow-up question will prompt the next insight.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_60.mp3'
    },
    {
      text: 'We’ll now go deeper into your solution and discuss alternative strategies—watch for a follow-up question to guide the discussion.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_61.mp3'
    },
    {
      text: 'Let’s examine how we can make your implementation more optimized, with a follow-up question to help identify areas of focus.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_62.mp3'
    },
    {
      text: 'Now that we have a solution, let’s focus on improving it, starting with a follow-up question.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_63.mp3'
    },
    {
      text: 'Let’s analyze your solution’s efficiency and explore enhancements—a follow-up question will follow to dive deeper.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_64.mp3'
    },
    {
      text: 'We’ll now explore ways to refine your code for better performance, and a follow-up question will help us get there.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Intro_Cues_audio_65.mp3'
    }
  ],
  Followup_Hint_Cues: [
    {
      text: 'Would you like to take a hint?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_66.mp3'
    },
    {
      text: 'Would you like to take a hint before we move forward?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_67.mp3'
    },
    {
      text: 'Do you want a hint to help guide your next steps?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_68.mp3'
    },
    {
      text: 'Would a hint help you at this stage of the problem?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_69.mp3'
    },
    {
      text: 'If you need assistance, feel free to take a hint.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_70.mp3'
    },
    {
      text: 'Let me know if a hint would help you at this point.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_71.mp3'
    },
    {
      text: 'Would you like some guidance through a hint?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_72.mp3'
    },
    {
      text: "If you're unsure, I can provide a hint to assist you.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_73.mp3'
    },
    {
      text: 'You can take a hint now if you think it would be useful.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_74.mp3'
    },
    {
      text: 'Need a push in the right direction? Take a hint.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_75.mp3'
    },
    {
      text: 'Would a hint help you make progress? Let me know.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Hint_Cues_audio_76.mp3'
    }
  ],
  Followup_Explanation_Cues: [
    {
      text: 'Can you briefly explain your approach?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_77.mp3'
    },
    {
      text: 'Can you give me a brief explanation of your approach?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_78.mp3'
    },
    {
      text: 'Summarize your approach in a few sentences.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_79.mp3'
    },
    {
      text: 'Can you quickly explain how you approached solving this problem?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_80.mp3'
    },
    {
      text: 'Give a concise explanation of your thought process.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_81.mp3'
    },
    {
      text: 'In a few words, describe the strategy you used to solve this.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_82.mp3'
    },
    {
      text: 'Can you outline your approach in a brief summary?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_83.mp3'
    },
    {
      text: 'Provide a short explanation of the logic behind your solution.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_84.mp3'
    },
    {
      text: 'Give a high-level overview of your approach.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_85.mp3'
    },
    {
      text: 'Summarize your solution and the reasoning behind it.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_86.mp3'
    },
    {
      text: 'Can you quickly walk me through the steps you took?',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Explanation_Cues_audio_87.mp3'
    }
  ],
  Followup_Timeout_Cues: [
    {
      text: "Let's wrap up this part in the next minute.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_88.mp3'
    },
    {
      text: "Let's finish up this section in the next minute before we move on.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_89.mp3'
    },
    {
      text: "We'll conclude this part within the next minute.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_90.mp3'
    },
    {
      text: "Let's wrap up this discussion in the next 60 seconds.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_91.mp3'
    },
    {
      text: "We'll finalize this part in one more minute.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_92.mp3'
    },
    {
      text: "Let's finish this section now and transition to the next step in 1 minute.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_93.mp3'
    },
    {
      text: 'We have one minute left to wrap up this discussion.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_94.mp3'
    },
    {
      text: "Let's quickly summarize and complete this section within a minute.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_95.mp3'
    },
    {
      text: 'This discussion will conclude in the next minute.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_96.mp3'
    },
    {
      text: 'One last minute before we move on to the next phase.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_97.mp3'
    },
    {
      text: "Let's wrap things up in the next 60 seconds.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Followup_Timeout_Cues_audio_98.mp3'
    }
  ],
  Hint_Intro_Cues: [
    {
      text: "Alright, can you tell me exactly where you're stuck and what kind of hint you need?",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_99.mp3'
    },
    {
      text: "Can you specify where exactly you're stuck and what type of hint would help?",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_100.mp3'
    },
    {
      text: "Tell me what part you're struggling with and what kind of hint you need.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_101.mp3'
    },
    {
      text: 'Where exactly are you facing difficulty? Let me know so I can give a relevant hint.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_102.mp3'
    },
    {
      text: "What's preventing you from moving forward? Let me know what type of hint would be helpful.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_103.mp3'
    },
    {
      text: 'Please describe your roadblock so I can provide the most useful hint.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_104.mp3'
    },
    {
      text: 'Where in the problem are you struggling? I can tailor a hint accordingly.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_105.mp3'
    },
    {
      text: "Could you pinpoint the part that's unclear? I'll provide a helpful hint.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_106.mp3'
    },
    {
      text: 'Let me know your specific challenge so I can offer guidance.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_107.mp3'
    },
    {
      text: "Describe the issue you're facing, and I'll guide you with a hint.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_108.mp3'
    },
    {
      text: "What's confusing you? I'll give a relevant hint.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Intro_Cues_audio_109.mp3'
    }
  ],
  Hint_Response_Cues: [
    {
      text: "Here's a hint to help you move forward.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Response_Cues_audio_110.mp3'
    },
    {
      text: 'This hint might point you in the right direction.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Response_Cues_audio_111.mp3'
    },
    {
      text: 'Try this hint—it could guide your next step.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Response_Cues_audio_112.mp3'
    },
    {
      text: 'Let me give you a nudge with this hint.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Response_Cues_audio_113.mp3'
    },
    {
      text: "Here's something to help you get unstuck.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Response_Cues_audio_114.mp3'
    },
    {
      text: 'Take this hint—it might clarify your path.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Response_Cues_audio_115.mp3'
    },
    {
      text: 'This might be the clue you need to progress.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Response_Cues_audio_116.mp3'
    },
    {
      text: "Here's a small push to get you going.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Response_Cues_audio_117.mp3'
    },
    {
      text: 'Let me share a pointer that could help.',
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Response_Cues_audio_118.mp3'
    },
    {
      text: "Here's a direction that might unlock it for you.",
      audioUrl: 'https://assets.languify.in/audio/coding-cues/Hint_Response_Cues_audio_119.mp3'
    }
  ]
};

export const getRandomAudioCue = (name) => {
  const cues = AudioCues[name];
  if (!cues || cues.length === 0) {
    return null;
  }
  const randomIndex = Math.floor(Math.random() * cues.length);
  return cues[randomIndex];
}

export const CodingTourSteps = [
  {
      id: "interviewer",
      message: "Your interviewer appears here. They will guide you through the interview by asking questions, providing hints as required. They will also give you a feedback based on your performance.",
      skipText: null,
      action: "Next",
      hideClose: true,
      data: {},
      tipNumber : 1,
      totalTip : 8
  },
  {
      id: "question-panel",
      message: 'Carefully read the coding challenge, including the description, input format, output format, and constraints. These details define the problem you need to solve and help guide your coding approach.',
      skipText: null,
      action: "Next",
      hideClose: true,
      data: {},
      tipNumber : 2,
      totalTip : 8
  },
  {
      id: "theme-toggle",
      message: "Write and test your solution in this editor. It supports multiple languages like C++, Java, and Python, with built-in syntax highlighting for ease of coding.",
      skipText: null,
      action: "Next",
      hideClose: true,
      data: {},
      tipNumber : 3,
      totalTip : 8
  },
  {
    id: "run-code",
    message: "To check if your code works correctly with the provided test cases, click the ‘Run’ button.",
    skipText: null,
    action: "Next",
    hideClose: true,
    data: {},
    tipNumber : 4,
    totalTip : 8
  },
  {
    id: "code-submit",
    message: "Click this when you're ready for the interviewer to review your solution. Note: You won't be able to make any changes after this step.",
    skipText: null,
    action: "Next",
    hideClose: true,
    data: {},
    tipNumber : 5,
    totalTip : 8
  },
  {
    id: "ask-interviewer",
    message: "Need help? Click “Ask your interviewer” to request hints, clarifications, or concept explanations at any time during the interview.",
    skipText: null,
    action: "Next",
    hideClose: true,
    data: {},
    tipNumber : 6,
    totalTip : 8
  },
  {
    id: "timer",
    message: "Watch the timer! Each section of the interview has a separate time limit. Make sure to complete your response within the allotted time.",
    skipText: null,
    action: "Next",
    hideClose: true,
    data: {},
    tipNumber : 7,
    totalTip : 8
  },
  {
    id: "end-session",
    message: "You may end the interview at any time. However, ending it before completing all sections will result in a lower score and the loss of 1 credit.",
    skipText: null,
    action: "Done",
    hideClose: true,
    data: {},
    tipNumber : 8,
    totalTip : 8
  },
];

export const AnalysisPhases = {
  Preparing_Analysis: {
    name: "Preparing Analysis",
    images: "https://languify-assets-v02.s3.ap-south-1.amazonaws.com/images/analysis4C.png",
    messages: [
      { message: "Capturing your problem-solving breakdown", duration: 8000 },
      { message: "Noting your edge-case considerations", duration: 7000 },
      { message: "Reviewing your code structure", duration: 8000 },
      { message: "Logging your data-structure choices", duration: 7000 },
      { message: "Charting your algorithm insights", duration: 7000 },
      { message: "Recording explanation flow", duration: 8000 },
      { message: "Assessing performance scaling", duration: 8000 },
      { message: "Tracking your iterative tweaks", duration: 7000 }
    ]
  },
  Evaluating_Performance: {
    name: "Evaluating Performance",
    images: "https://languify-assets-v02.s3.ap-south-1.amazonaws.com/images/evaluating4c.png",
    messages: [
      { message: "Analyzing your step-by-step logic", duration: 7000 },
      { message: "Evaluating boundary-value checks", duration: 7000 },
      { message: "Inspecting modularity and naming", duration: 8000 },
      { message: "Verifying algorithmic efficiency", duration: 7000 },
      { message: "Matching your approach to problem complexity", duration: 7000 },
      { message: "Reviewing how clearly you communicated", duration: 8000 },
      { message: "Analyzing time and space complexity", duration: 8000 },
      { message: "Checking follow-up optimizations", duration: 8000 }
    ]
  },
  Finalizing_Feedback: {
    name: "Finalizing Feedback",
    images: "https://languify-assets-v02.s3.ap-south-1.amazonaws.com/images/finalizing.png",
    static: [
      { message: "Finalizing actionable insights", duration: 10000 },
      { message: "Highlighting your strengths", duration: 10000 },
      { message: "Identifying growth areas", duration: 10000 },
      { message: "Linking to best-practice tips", duration: 10000 },
      { message: "Packaging into your personalized report", duration: 10000 }
    ],
    loop: [
      { message: "Finalizing a report that guides your next step", duration: 1000 },
      { message: "Hold tight… we're nearly finished!", duration: 1000 }
    ]
  },
  Completed: {
    name: "Completed",
    images: "https://languify-assets-v02.s3.ap-south-1.amazonaws.com/images/completed4c.png",
    messages: [
      { message: "Your feedback report is ready.", duration: null }
    ]
  }
};
